/**
 * Route copy for `src/routes/automations` (keys: `routes.automations.<file>.<key>`).
 *
 * `fr` is the source; `en` and `ar` are typed against it, so a missing or extra
 * key fails `tsc` (and parity.test.ts). Keys are referenced from the route files
 * through `t()` / `tr()` — edit values freely, never rename a key without its call site.
 *
 * Locale file: en (typed against ./fr). One file per locale so
 * every non-default locale is a separate, lazily-loaded chunk.
 */

import type { Catalog } from './fr';

const en: Catalog = {
  automationsPage: {
    ruleCreatedDisabledByDefault: 'Rule created (disabled by default).',
    deleteTheRule: 'Delete the rule',
    deleteNameThisActionIsPermanent: 'Delete “{{name}}”? This action is permanent.',
    delete: 'Delete',
    ruleDeleted: 'Rule deleted.',
    conditionalAutomations: '⚙️ Conditional automations',
    triggerAnActionCtaCommentBoost: 'Trigger an action (CTA comment, boost, recycling) when a post crosses a threshold or its own average. Everything is off by default; automatic mode requires a prior simulation.',
    cancel: 'Cancel',
    newRule: 'New rule',
    loadingRules: 'Loading rules…',
    conditionalAutomationsAreComingSoon: 'Conditional automations are coming soon.',
    couldNotLoadTheRulesErrormsg: 'Could not load the rules: {{errorMsg}}',
    noRulesYetCreateOneIt: 'No rules yet. Create one: it stays disabled until you enable it.',
    simulationComplete: 'Simulation complete.',
    firstRunASimulationBeforeEnabling: 'First run a simulation before enabling automatic mode.',
    unnamedRule: 'Unnamed rule',
    cooldownCooldownHoursHMaxMax: 'Cooldown {{cooldown_hours}} h · max {{max_runs_per_post}}/post',
    allPlatforms: ' · all platforms',
    enabled: 'Enabled',
    disabled: 'Disabled',
    mode: 'Mode',
    simulationRequired: ' — simulation required',
    simulating: 'Simulating…',
    simulateDryRun: 'Simulate (dry run)',
    automaticModeIsLockedUntilA: 'Automatic mode is locked until a simulation has been run (a trust safeguard).',
    simulationEvaluatedPostSEvaluatedLength: 'Simulation — {{evaluated}} post(s) evaluated, {{length}}',
    matchEs: 'match(es)',
    blocked: 'Blocked:',
    compliance: 'compliance',
    giveTheRuleAName: 'Give the rule a name.',
    name: 'Name',
    boostThePostsThatTakeOff: 'Boost the posts that take off',
    trigger: 'Trigger',
    multipleOfTheAverageEG: 'Multiple of the average (e.g. 1.5 = 150%)',
    engagementThreshold: 'Engagement threshold',
    action: 'Action',
    cooldownHours: 'Cooldown (hours)',
    maxPerPost: 'Max per post',
    platformsEmptyAll: 'Platforms (empty = all)',
    theRuleIsCreated: 'The rule is created',
    disabled2: 'disabled',
    andInSuggestModeYouCan: 'and in “suggest” mode. You can enable it, then — after a simulation — switch to automatic.',
    creating: 'Creating…',
    createRule: 'Create rule',
  },
};

export default en;
